<template>
    <div>
<!--    <ElderHeader/>-->
    <v-card height="450px" class="box">
        <v-navigation-drawer
                absolute
                permanent
                right




        >
            <template>
                <div class="student-div" >

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{applicant.applicantDocument.applicationId}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="student-pic">
                    <div v-if="applicant.profilePictureUrl===null">
                        <v-avatar color="red"  width="80px" height="80px" min-width="80px">
                            <span class="white--text headline">{{applicant.firstName.toString().charAt(0)}} {{applicant.lastName.toString().charAt(0)}}</span>
                        </v-avatar>

                    </div>
                    <v-list-item-avatar v-else width="80px" height="80px" min-width="80px">
                        <img :src="applicant.profilePictureUrl" alt="applicant">
                    </v-list-item-avatar>
                </v-list-item>
                </div>
                <v-list-item>

                    <v-list-item-content  >
                        <v-list-item-title class="student-name">{{applicant.firstName}} {{applicant.lastName}} </v-list-item-title>
                        <v-list-item-subtitle class="applicant-status">{{applicant.applicationStatus}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

            </template>

            <v-divider></v-divider>

            <v-list dense class="ml-5">
                <div class="payment" v-if="applicant.applicationStatus==='TESTED'" >
                    <InterviewDialog />

                </div>
                <div class="payment" v-if="applicant.applicationStatus==='INVITED_FOR_INTERVIEW' || applicant.applicationStatus==='ACCEPTED_INTERVIEW'|| applicant.applicationStatus==='INTERVIEWING'">

                    <ViewInterviewSchedule/>

                </div>
                    <div v-else-if="applicant.applicationStatus==='INTERVIEWED' || applicant.applicationStatus==='OFFERED_ADMISSION'  || applicant.applicationStatus==='ACCEPTED_ADMISSION' ||
                    applicant.applicationStatus==='APPLICATION_DECLINED' ||applicant.applicationStatus==='REJECTED_ADMISSION_OFFER' || applicant.applicationStatus==='ENROLLED' || applicant.applicationStatus==='CHECKED_IN' || applicant.applicationStatus==='NATIVE'">
                      <ViewCompletedInterview/>
                    </div>

<!--              <div-->
<!--                  v-if="applicant.applicationStatus==='OFFERED_ADMISSION'  || applicant.applicationStatus==='ACCEPTED_ADMISSION' || applicant.applicationStatus==='ENROLLED'"-->
<!--                  class="payment">-->
<!--                <PaymentModal/>-->

<!--              </div>-->

<!--              <div class="payment" v-if="applicant.applicationStatus==='OFFERED_ADMISSION'  || applicant.applicationStatus==='ACCEPTED_ADMISSION' ||-->
<!--                          applicant.applicationStatus==='APPLICATION_DECLINED' || applicant.applicationStatus==='REJECTED_ADMISSION_OFFER'">-->
<!--                <AssignCohort/>-->
<!--              </div>-->


                <CommentDialog />
<!--                <DecisionDialog/>-->
<!--                <ViewInterviewSchedule/>-->
            </v-list>
        </v-navigation-drawer>
    </v-card>
    </div>
</template>



<script>
import ViewInterviewSchedule from "./ElderDashboardBody/ViewInterviewSchedule";
import InterviewDialog from "./ElderDashboardBody/InterviewDialog";
import CommentDialog from "./ElderDashboardBody/CommentDialog";
import {mapGetters} from "vuex";
import ViewCompletedInterview from "./ElderDashboardBody/Profile/ViewCompletedInterview";
// import PaymentModal from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/PaymentModal";
// import AssignCohort from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/AssignCohort";


export default {
  name: "ApplicantMenu",
  components: {
     ViewCompletedInterview, InterviewDialog, CommentDialog, ViewInterviewSchedule
  },
  computed: mapGetters([
    'applicant'
  ])


};
</script>

<style scoped>
    .applicant-status{
        background: #FFF0CE;
        border: 2px solid #FFB403;
        box-sizing: border-box;
        border-radius: 8px;
        margin-left: 50px;
        /*margin-right: 50px;*/
        text-align: center;
        margin-bottom: 25px;
        padding: 5px;
        width: auto  !important;


    }
    .student-div{
        align-content: center;
        align-items: center;
        text-align: center;
        align-self: center;
        alignment: center;

    }
    .student-pic{
        margin-left: 85px;
        width: 100% !important;
    }
    .student-name{
        margin-left: 85px;
        margin-bottom: 10px !important;
    }

    .box{
        box-shadow: none!important;
    }
    .payment{
      margin-top: -20px;
    }


</style>